/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */
import type {
  CompleteCreditNotePreview,
  CreateCreditNote,
  CreditNote,
  CreditNoteList,
  CustomCreateCreditNote,
  DocumentVersion,
  DocumentVersionList,
  Error,
  GetCreditNoteByIdParams,
  GetCreditNotesParams,
  GetShareableCreditNoteHtmlParams,
  GetShareableCreditNotePdfParams,
  PartialCreditNotePreview,
  RenderCreditNotePreviewParams,
  UpdateCreditNote,
  ValidationError,
  VoidCreditNoteBody
} from '../model';

import { customFetch } from '../../mutator/custom-fetch';

/**
 * Retrieve credit note data using a shareable token. No authentication required. Returns full credit note data for rendering.
 * @summary View shareable credit note
 */
export type getShareableCreditNoteResponse200 = {
  data: CreditNote
  status: 200
}

export type getShareableCreditNoteResponse404 = {
  data: void
  status: 404
}

export type getShareableCreditNoteResponseSuccess = (getShareableCreditNoteResponse200) & {
  headers: Headers;
};
export type getShareableCreditNoteResponseError = (getShareableCreditNoteResponse404) & {
  headers: Headers;
};

export type getShareableCreditNoteResponse = (getShareableCreditNoteResponseSuccess | getShareableCreditNoteResponseError)

export const getGetShareableCreditNoteUrl = (shareableId: string,) => {


  

  return `/credit-notes/shareable/${shareableId}`
}

export const getShareableCreditNote = async (shareableId: string, options?: RequestInit): Promise<getShareableCreditNoteResponse> => {
  
  return customFetch<getShareableCreditNoteResponse>(getGetShareableCreditNoteUrl(shareableId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Get credit note as HTML preview using a shareable token. No authentication required. Supports multiple languages via locale query parameter.
 * @summary Get shareable credit note as HTML
 */
export type getShareableCreditNoteHtmlResponse200 = {
  data: string
  status: 200
}

export type getShareableCreditNoteHtmlResponse404 = {
  data: void
  status: 404
}

export type getShareableCreditNoteHtmlResponseSuccess = (getShareableCreditNoteHtmlResponse200) & {
  headers: Headers;
};
export type getShareableCreditNoteHtmlResponseError = (getShareableCreditNoteHtmlResponse404) & {
  headers: Headers;
};

export type getShareableCreditNoteHtmlResponse = (getShareableCreditNoteHtmlResponseSuccess | getShareableCreditNoteHtmlResponseError)

export const getGetShareableCreditNoteHtmlUrl = (shareableId: string,
    params?: GetShareableCreditNoteHtmlParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/credit-notes/shareable/${shareableId}/html?${stringifiedParams}` : `/credit-notes/shareable/${shareableId}/html`
}

export const getShareableCreditNoteHtml = async (shareableId: string,
    params?: GetShareableCreditNoteHtmlParams, options?: RequestInit): Promise<getShareableCreditNoteHtmlResponse> => {
  
  return customFetch<getShareableCreditNoteHtmlResponse>(getGetShareableCreditNoteHtmlUrl(shareableId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Download credit note as PDF using a shareable token. No authentication required. Supports multiple languages via locale query parameter.
 * @summary Download shareable credit note as PDF
 */
export type getShareableCreditNotePdfResponse200 = {
  data: Blob
  status: 200
}

export type getShareableCreditNotePdfResponse404 = {
  data: void
  status: 404
}

export type getShareableCreditNotePdfResponseSuccess = (getShareableCreditNotePdfResponse200) & {
  headers: Headers;
};
export type getShareableCreditNotePdfResponseError = (getShareableCreditNotePdfResponse404) & {
  headers: Headers;
};

export type getShareableCreditNotePdfResponse = (getShareableCreditNotePdfResponseSuccess | getShareableCreditNotePdfResponseError)

export const getGetShareableCreditNotePdfUrl = (shareableId: string,
    params?: GetShareableCreditNotePdfParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/credit-notes/shareable/${shareableId}/pdf?${stringifiedParams}` : `/credit-notes/shareable/${shareableId}/pdf`
}

export const getShareableCreditNotePdf = async (shareableId: string,
    params?: GetShareableCreditNotePdfParams, options?: RequestInit): Promise<getShareableCreditNotePdfResponse> => {
  
  return customFetch<getShareableCreditNotePdfResponse>(getGetShareableCreditNotePdfUrl(shareableId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Download credit note as e-SLOG 2.0 XML (Slovenian electronic invoice format) using a shareable token. No authentication required. Only available for Slovenian entities with valid e-SLOG validation.
 * @summary Download shareable credit note as e-SLOG XML
 */
export type getShareableCreditNoteEslogResponse200 = {
  data: string
  status: 200
}

export type getShareableCreditNoteEslogResponse404 = {
  data: void
  status: 404
}

export type getShareableCreditNoteEslogResponseSuccess = (getShareableCreditNoteEslogResponse200) & {
  headers: Headers;
};
export type getShareableCreditNoteEslogResponseError = (getShareableCreditNoteEslogResponse404) & {
  headers: Headers;
};

export type getShareableCreditNoteEslogResponse = (getShareableCreditNoteEslogResponseSuccess | getShareableCreditNoteEslogResponseError)

export const getGetShareableCreditNoteEslogUrl = (shareableId: string,) => {


  

  return `/credit-notes/shareable/${shareableId}/eslog`
}

export const getShareableCreditNoteEslog = async (shareableId: string, options?: RequestInit): Promise<getShareableCreditNoteEslogResponse> => {
  
  return customFetch<getShareableCreditNoteEslogResponse>(getGetShareableCreditNoteEslogUrl(shareableId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Create a new credit note with line items.
Customer is optional - can be omitted for retail/convenience store sales where customer information isn't needed, or added inline without referencing a customer_id.
The credit note number is auto-generated based on the entity's number format settings.
Taxes are calculated automatically based on the tax rates provided.
 * @summary Create a new credit note
 */
export type createCreditNoteResponse201 = {
  data: CreditNote
  status: 201
}

export type createCreditNoteResponse400 = {
  data: Error
  status: 400
}

export type createCreditNoteResponse401 = {
  data: Error
  status: 401
}

export type createCreditNoteResponse403 = {
  data: Error
  status: 403
}

export type createCreditNoteResponse404 = {
  data: Error
  status: 404
}

export type createCreditNoteResponse422 = {
  data: ValidationError
  status: 422
}

export type createCreditNoteResponse500 = {
  data: Error
  status: 500
}

export type createCreditNoteResponseSuccess = (createCreditNoteResponse201) & {
  headers: Headers;
};
export type createCreditNoteResponseError = (createCreditNoteResponse400 | createCreditNoteResponse401 | createCreditNoteResponse403 | createCreditNoteResponse404 | createCreditNoteResponse422 | createCreditNoteResponse500) & {
  headers: Headers;
};

export type createCreditNoteResponse = (createCreditNoteResponseSuccess | createCreditNoteResponseError)

export const getCreateCreditNoteUrl = () => {


  

  return `/credit-notes`
}

export const createCreditNote = async (createCreditNote: CreateCreditNote, options?: RequestInit): Promise<createCreditNoteResponse> => {
  
  return customFetch<createCreditNoteResponse>(getCreateCreditNoteUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createCreditNote,)
  }
);}
  

/**
 * Retrieve a paginated list of credit notes with optional filtering and sorting.
Supports cursor-based pagination, flexible JSON querying with MongoDB-style operators, full-text search, and sorting.
 * @summary List all credit notes
 */
export type getCreditNotesResponse200 = {
  data: CreditNoteList
  status: 200
}

export type getCreditNotesResponse400 = {
  data: Error
  status: 400
}

export type getCreditNotesResponse401 = {
  data: Error
  status: 401
}

export type getCreditNotesResponse403 = {
  data: Error
  status: 403
}

export type getCreditNotesResponse404 = {
  data: Error
  status: 404
}

export type getCreditNotesResponse500 = {
  data: Error
  status: 500
}

export type getCreditNotesResponseSuccess = (getCreditNotesResponse200) & {
  headers: Headers;
};
export type getCreditNotesResponseError = (getCreditNotesResponse400 | getCreditNotesResponse401 | getCreditNotesResponse403 | getCreditNotesResponse404 | getCreditNotesResponse500) & {
  headers: Headers;
};

export type getCreditNotesResponse = (getCreditNotesResponseSuccess | getCreditNotesResponseError)

export const getGetCreditNotesUrl = (params?: GetCreditNotesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/credit-notes?${stringifiedParams}` : `/credit-notes`
}

export const getCreditNotes = async (params?: GetCreditNotesParams, options?: RequestInit): Promise<getCreditNotesResponse> => {
  
  return customFetch<getCreditNotesResponse>(getGetCreditNotesUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Create a credit note with pre-calculated totals from an external system.
The caller provides `total`, `total_with_tax`, `total_discount`, and `taxes` at the document level, and `total`/`total_with_tax` on each line item.
When `calculation_mode` is omitted, Space Invoices preserves pass-through behavior and accepts the supplied totals as-is.
When `calculation_mode` is provided, Space Invoices validates the supplied totals against that calculation mode before creating the document.
All other logic (numbering, fiscalization, customer handling, payments, lifecycle hooks) is identical to the standard create endpoint.
 * @summary Create credit note with pre-calculated totals
 */
export type createCustomCreditNoteResponse201 = {
  data: CreditNote
  status: 201
}

export type createCustomCreditNoteResponse400 = {
  data: Error
  status: 400
}

export type createCustomCreditNoteResponse401 = {
  data: Error
  status: 401
}

export type createCustomCreditNoteResponse403 = {
  data: Error
  status: 403
}

export type createCustomCreditNoteResponse404 = {
  data: Error
  status: 404
}

export type createCustomCreditNoteResponse422 = {
  data: ValidationError
  status: 422
}

export type createCustomCreditNoteResponse500 = {
  data: Error
  status: 500
}

export type createCustomCreditNoteResponseSuccess = (createCustomCreditNoteResponse201) & {
  headers: Headers;
};
export type createCustomCreditNoteResponseError = (createCustomCreditNoteResponse400 | createCustomCreditNoteResponse401 | createCustomCreditNoteResponse403 | createCustomCreditNoteResponse404 | createCustomCreditNoteResponse422 | createCustomCreditNoteResponse500) & {
  headers: Headers;
};

export type createCustomCreditNoteResponse = (createCustomCreditNoteResponseSuccess | createCustomCreditNoteResponseError)

export const getCreateCustomCreditNoteUrl = () => {


  

  return `/credit-notes/custom`
}

export const createCustomCreditNote = async (customCreateCreditNote: CustomCreateCreditNote, options?: RequestInit): Promise<createCustomCreditNoteResponse> => {
  
  return customFetch<createCustomCreditNoteResponse>(getCreateCustomCreditNoteUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      customCreateCreditNote,)
  }
);}
  

/**
 * Retrieve a single credit note by its unique identifier. Returns the complete credit note details including all line items, customer information, and calculated totals.
 * @summary Get credit note by ID
 */
export type getCreditNoteByIdResponse200 = {
  data: CreditNote
  status: 200
}

export type getCreditNoteByIdResponse401 = {
  data: Error
  status: 401
}

export type getCreditNoteByIdResponse403 = {
  data: Error
  status: 403
}

export type getCreditNoteByIdResponse404 = {
  data: Error
  status: 404
}

export type getCreditNoteByIdResponse500 = {
  data: Error
  status: 500
}

export type getCreditNoteByIdResponseSuccess = (getCreditNoteByIdResponse200) & {
  headers: Headers;
};
export type getCreditNoteByIdResponseError = (getCreditNoteByIdResponse401 | getCreditNoteByIdResponse403 | getCreditNoteByIdResponse404 | getCreditNoteByIdResponse500) & {
  headers: Headers;
};

export type getCreditNoteByIdResponse = (getCreditNoteByIdResponseSuccess | getCreditNoteByIdResponseError)

export const getGetCreditNoteByIdUrl = (id: string,
    params?: GetCreditNoteByIdParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/credit-notes/${id}?${stringifiedParams}` : `/credit-notes/${id}`
}

export const getCreditNoteById = async (id: string,
    params?: GetCreditNoteByIdParams, options?: RequestInit): Promise<getCreditNoteByIdResponse> => {
  
  return customFetch<getCreditNoteByIdResponse>(getGetCreditNoteByIdUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Update an existing credit note.
Creates a version snapshot before applying changes.
Cannot update voided or FURS-fiscalized credit notes.
If items are provided, they replace all existing items.
 * @summary Update a credit note
 */
export type updateCreditNoteResponse200 = {
  data: CreditNote
  status: 200
}

export type updateCreditNoteResponse400 = {
  data: Error
  status: 400
}

export type updateCreditNoteResponse401 = {
  data: Error
  status: 401
}

export type updateCreditNoteResponse403 = {
  data: Error
  status: 403
}

export type updateCreditNoteResponse404 = {
  data: Error
  status: 404
}

export type updateCreditNoteResponse422 = {
  data: ValidationError
  status: 422
}

export type updateCreditNoteResponse500 = {
  data: Error
  status: 500
}

export type updateCreditNoteResponseSuccess = (updateCreditNoteResponse200) & {
  headers: Headers;
};
export type updateCreditNoteResponseError = (updateCreditNoteResponse400 | updateCreditNoteResponse401 | updateCreditNoteResponse403 | updateCreditNoteResponse404 | updateCreditNoteResponse422 | updateCreditNoteResponse500) & {
  headers: Headers;
};

export type updateCreditNoteResponse = (updateCreditNoteResponseSuccess | updateCreditNoteResponseError)

export const getUpdateCreditNoteUrl = (id: string,) => {


  

  return `/credit-notes/${id}`
}

export const updateCreditNote = async (id: string,
    updateCreditNote: UpdateCreditNote, options?: RequestInit): Promise<updateCreditNoteResponse> => {
  
  return customFetch<updateCreditNoteResponse>(getUpdateCreditNoteUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateCreditNote,)
  }
);}
  

/**
 * Retrieve the version history for a credit note. Each version represents the document state before an update was applied.
 * @summary Get credit note version history
 */
export type getCreditNoteVersionsResponse200 = {
  data: DocumentVersionList
  status: 200
}

export type getCreditNoteVersionsResponse401 = {
  data: Error
  status: 401
}

export type getCreditNoteVersionsResponse403 = {
  data: Error
  status: 403
}

export type getCreditNoteVersionsResponse404 = {
  data: Error
  status: 404
}

export type getCreditNoteVersionsResponse500 = {
  data: Error
  status: 500
}

export type getCreditNoteVersionsResponseSuccess = (getCreditNoteVersionsResponse200) & {
  headers: Headers;
};
export type getCreditNoteVersionsResponseError = (getCreditNoteVersionsResponse401 | getCreditNoteVersionsResponse403 | getCreditNoteVersionsResponse404 | getCreditNoteVersionsResponse500) & {
  headers: Headers;
};

export type getCreditNoteVersionsResponse = (getCreditNoteVersionsResponseSuccess | getCreditNoteVersionsResponseError)

export const getGetCreditNoteVersionsUrl = (id: string,) => {


  

  return `/credit-notes/${id}/versions`
}

export const getCreditNoteVersions = async (id: string, options?: RequestInit): Promise<getCreditNoteVersionsResponse> => {
  
  return customFetch<getCreditNoteVersionsResponse>(getGetCreditNoteVersionsUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Retrieve a specific version snapshot of a credit note.
 * @summary Get specific credit note version
 */
export type getCreditNoteVersionResponse200 = {
  data: DocumentVersion
  status: 200
}

export type getCreditNoteVersionResponse401 = {
  data: Error
  status: 401
}

export type getCreditNoteVersionResponse403 = {
  data: Error
  status: 403
}

export type getCreditNoteVersionResponse404 = {
  data: Error
  status: 404
}

export type getCreditNoteVersionResponse500 = {
  data: Error
  status: 500
}

export type getCreditNoteVersionResponseSuccess = (getCreditNoteVersionResponse200) & {
  headers: Headers;
};
export type getCreditNoteVersionResponseError = (getCreditNoteVersionResponse401 | getCreditNoteVersionResponse403 | getCreditNoteVersionResponse404 | getCreditNoteVersionResponse500) & {
  headers: Headers;
};

export type getCreditNoteVersionResponse = (getCreditNoteVersionResponseSuccess | getCreditNoteVersionResponseError)

export const getGetCreditNoteVersionUrl = (id: string,
    version: number,) => {


  

  return `/credit-notes/${id}/versions/${version}`
}

export const getCreditNoteVersion = async (id: string,
    version: number, options?: RequestInit): Promise<getCreditNoteVersionResponse> => {
  
  return customFetch<getCreditNoteVersionResponse>(getGetCreditNoteVersionUrl(id,version),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Render an HTML preview of a credit note without saving to the database. Perfect for displaying live previews in credit note creation/edit forms. Supports both partial mode (allows incomplete data for drafts) and complete mode (validates all required fields).
 * @summary Render credit note preview
 */
export type renderCreditNotePreviewResponse200 = {
  data: string
  status: 200
}

export type renderCreditNotePreviewResponse400 = {
  data: Error
  status: 400
}

export type renderCreditNotePreviewResponse401 = {
  data: Error
  status: 401
}

export type renderCreditNotePreviewResponse403 = {
  data: Error
  status: 403
}

export type renderCreditNotePreviewResponse404 = {
  data: Error
  status: 404
}

export type renderCreditNotePreviewResponse422 = {
  data: ValidationError
  status: 422
}

export type renderCreditNotePreviewResponse500 = {
  data: Error
  status: 500
}

export type renderCreditNotePreviewResponseSuccess = (renderCreditNotePreviewResponse200) & {
  headers: Headers;
};
export type renderCreditNotePreviewResponseError = (renderCreditNotePreviewResponse400 | renderCreditNotePreviewResponse401 | renderCreditNotePreviewResponse403 | renderCreditNotePreviewResponse404 | renderCreditNotePreviewResponse422 | renderCreditNotePreviewResponse500) & {
  headers: Headers;
};

export type renderCreditNotePreviewResponse = (renderCreditNotePreviewResponseSuccess | renderCreditNotePreviewResponseError)

export const getRenderCreditNotePreviewUrl = (params?: RenderCreditNotePreviewParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/credit-notes/render?${stringifiedParams}` : `/credit-notes/render`
}

export const renderCreditNotePreview = async (partialCreditNotePreviewCompleteCreditNotePreview: PartialCreditNotePreview | CompleteCreditNotePreview,
    params?: RenderCreditNotePreviewParams, options?: RequestInit): Promise<renderCreditNotePreviewResponse> => {
  
  return customFetch<renderCreditNotePreviewResponse>(getRenderCreditNotePreviewUrl(params),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      partialCreditNotePreviewCompleteCreditNotePreview,)
  }
);}
  

/**
 * Void a credit note for technical reasons (duplicate, error, etc.). For FURS-fiscalized credit notes, automatically submits technical cancellation to FURS. All linked payments are soft-deleted, reversing their effect on invoice totals.
 * @summary Void a credit note
 */
export type voidCreditNoteResponse200 = {
  data: CreditNote
  status: 200
}

export type voidCreditNoteResponse400 = {
  data: Error
  status: 400
}

export type voidCreditNoteResponse401 = {
  data: Error
  status: 401
}

export type voidCreditNoteResponse403 = {
  data: Error
  status: 403
}

export type voidCreditNoteResponse404 = {
  data: Error
  status: 404
}

export type voidCreditNoteResponse422 = {
  data: ValidationError
  status: 422
}

export type voidCreditNoteResponse500 = {
  data: Error
  status: 500
}

export type voidCreditNoteResponseSuccess = (voidCreditNoteResponse200) & {
  headers: Headers;
};
export type voidCreditNoteResponseError = (voidCreditNoteResponse400 | voidCreditNoteResponse401 | voidCreditNoteResponse403 | voidCreditNoteResponse404 | voidCreditNoteResponse422 | voidCreditNoteResponse500) & {
  headers: Headers;
};

export type voidCreditNoteResponse = (voidCreditNoteResponseSuccess | voidCreditNoteResponseError)

export const getVoidCreditNoteUrl = (id: string,) => {


  

  return `/credit-notes/${id}/void`
}

export const voidCreditNote = async (id: string,
    voidCreditNoteBody: VoidCreditNoteBody, options?: RequestInit): Promise<voidCreditNoteResponse> => {
  
  return customFetch<voidCreditNoteResponse>(getVoidCreditNoteUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      voidCreditNoteBody,)
  }
);}
  

